"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusManager = void 0;
var browser_1 = require("@devexpress/utils/lib/browser");
var FocusManager = (function () {
    function FocusManager(canvasManager, owner, inputController, eventManager) {
        this.canvasManager = canvasManager;
        this.owner = owner;
        this.inputController = inputController;
        this.eventManager = eventManager;
    }
    Object.defineProperty(FocusManager.prototype, "isInFocus", {
        get: function () {
            return this.isFocus;
        },
        set: function (focused) {
            if (this.isFocus !== focused) {
                this.isFocus = focused;
                this.canvasManager.focusChanged(focused);
            }
        },
        enumerable: false,
        configurable: true
    });
    FocusManager.prototype.captureFocus = function () {
        if (this.owner.canCaptureFocus()) {
            this.owner.onCaptureFocus();
            if (!browser_1.Browser.MacOSMobilePlatform || this.owner.isInitialized ||
                browser_1.Browser.MacOSMobilePlatform && window.self !== window.top)
                this.inputController.captureFocus();
            this.eventManager.onFocusIn();
        }
    };
    return FocusManager;
}());
exports.FocusManager = FocusManager;
